import styled from '@emotion/styled';
import { MOBILE_QRY } from '~/config';

interface PillProps {
  variant?: 'success' | 'primary' | 'secondary' | 'danger';
  size?: 'md' | 'sm';
}

const Pill = styled.div<PillProps>`
  width: auto;
  align-items: center;
  border-radius: 8px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  text-wrap: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;

  ${MOBILE_QRY} {
    padding: 4px 8px;
    font-size: 14px;
  }

  background: ${({ variant }) =>
    variant === 'success'
      ? '#E3FCEF'
      : variant === 'primary'
        ? '#E2ECFD'
        : variant === 'secondary'
          ? '#E5E4E7'
          : variant === 'danger'
            ? '#FCEBE6'
            : '#E5E4E7'}; /* Default to secondary */

  color: ${({ variant }) =>
    variant === 'success'
      ? '#00875A'
      : variant === 'primary'
        ? '#215EEB'
        : variant === 'secondary'
          ? '#56555E'
          : variant === 'danger'
            ? '#CB4621'
            : '#56555E'}; /* Default to secondary */
`;

export default Pill;
